import React from "react";
import { useTranslation } from "react-i18next";
import { LuigisboxHitItem } from "./luigisboxAutocompleteTypes";

interface LuigisboxAutocompleteCategoriesBlockProperties {
    readonly categories: LuigisboxHitItem<"category">[];
    readonly onAnchorClick: (categoryUrl: string) => void;
}

export default function LuigisboxAutocompleteCategoriesBlock({
    categories,
    onAnchorClick,
}: LuigisboxAutocompleteCategoriesBlockProperties):
  | React.JSX.Element
  | undefined {
    const { t } = useTranslation("header");

    const categoryList: React.JSX.Element[] = categories.map((category) => <div className="autocomplete-category" key={category.attributes.title}>
        <a
            href={category.url}
            className="autocomplete-category-link"
            onClick={(event): void => {
                event.preventDefault();
                onAnchorClick(category.url);
            }}
        >
            <i className="fas fa-folder"></i>
            <span dangerouslySetInnerHTML={{ __html: category.attributes.title }}></span>
        </a>
    </div>);

    if (categoryList.length === 0) {
        return undefined;
    }

    return (
        <div>
            <div className="autocomplete-section">
                <span>{t("categories")}</span>
            </div>
            <div className="autocomplete-results autocomplete-results-categories">
                {categoryList}
            </div>
        </div>
    );
}
